var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 7,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4526 19.9262L41.4456 14.9737L32.3064 9V12.8205L38.3346 16.7896L38.3393 19.8319L35.5389 21.728L33.6284 20.3342V17.9735L30.5151 15.8439V20.1408L25.5799 23.169L25.5706 31.1684L22.0813 33.1329L20.2899 31.7297V29.4138L22.4105 27.9611V27.9422V24.3575L18.5942 26.9116L15.677 25.0132L13.0122 26.7584L17.1765 29.6096V31.3595L14.1753 33.39L11.1133 31.317V24.4189L15.6584 21.3412L15.6631 18.3815L21.4927 22.1359L26.3928 18.8744L23.4055 17.1315L21.4507 18.4498L17.1929 15.634L21.9948 12.8347L26.1545 15.2732V11.6366L21.9995 9.20045L12.5544 14.7072L12.5474 19.662L8 22.742V32.9938L12.5474 36.0738L12.5544 41.0287L21.6936 47V43.1819L15.6654 39.2128L15.6607 36.1705L18.4611 34.2744L20.3716 35.6681V38.0289L23.4849 40.1585V35.8615L28.4901 32.8334L28.5461 24.8339L31.9187 22.8694L33.7101 24.2727V26.5885L31.5894 28.0412V28.0601V31.6448L35.4058 29.0907L38.323 30.9892L40.9878 29.244L36.8235 26.3904V24.6429L39.8247 22.6124L42.8867 24.6854V31.5835L38.3416 34.6611L38.3369 37.6208L32.5073 33.8641L27.6072 37.1044L30.5945 38.8448L32.5493 37.5524L36.8071 40.3683L32.0052 43.1677L27.8455 40.7291V44.3634L32.0005 46.7995L41.4456 41.2952L41.4526 36.3402L46 33.2602V23.0062L41.4526 19.9262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPhoto);
export default __webpack_public_path__ + "static/media/ai_photo.b0cd20d43c819d648a124c6f3c3f14d6.svg";
export { ForwardRef as ReactComponent };